import { Component } from '@angular/core'

/** El hueco de una notificación mientras llega: la fila de `notification-item`. */
@Component({
  selector: 'notification-item-skeleton',
  host: { class: 'card-panel flex items-start gap-3 rounded-2xl p-3', 'aria-hidden': 'true' },
  template: `
    <span class="skeleton size-9 shrink-0 rounded-full"></span>

    <span class="flex min-w-0 flex-1 flex-col gap-2">
      <span class="skeleton h-4 w-3/4"></span>
      <span class="skeleton h-3 w-full"></span>
      <span class="skeleton h-3 w-24"></span>
    </span>
  `
})
export class NotificationItemSkeleton {}
